var Observable_1 = require('../../Observable');
var filter_1 = require('../../operator/filter');
Observable_1.Observable.prototype.filter = filter_1.filter;
//# sourceMappingURL=filter.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/filter.js
 ** module id = 348
 ** module chunks = 1
 **/